export default function rolesReducer (state = null, action) {
  switch (action.type) {
    case 'SET_ROLES':
      return action.payload;
    default:
      return state;
  }
};